export default {
  login: '/login',
  logout: '/logout',
  dashboard: '/dashboard',
};
